import $ from 'jquery';

let is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
let is_safari = navigator.userAgent.indexOf("Safari") > -1;
function isSafariBrowser(){
    if (is_safari){
        if (is_chrome)  // Chrome seems to have both Chrome and Safari userAgents
            return false;
        else
            return true;
    }
    return false;
}

if (!isSafariBrowser()){
    let $block = $('.content-tabs-block--detail-text');
    let parentHeight = $block.height();
    let $button = $('.content-tabs-block--detail-text__button');

    let lineHeight = parseInt($block.css('lineHeight'));
    let lines = parentHeight / lineHeight;

    if (lines > 20) {
        $button.show();
        $block.css({
            '-webkit-line-clamp': '15'
        });

    } else {
        $button.hide();
    }
$('.content-tabs-block--detail-text__button').on('click', function () {
    parentHeight = $block.height();
    lines = parentHeight / lineHeight;

    if (lines > 15 && $button.text()!=='Развернуть описание') {
        $button.text('Развернуть описание');
        $block.css({
            '-webkit-line-clamp': '15'
        });
        $('html, body').animate({
            scrollTop: $('.content-tabs').offset().top - 100  // класс объекта к которому приезжаем
        }, 500);
    } else {
        $button.text('Свернуть описание');
        $block.css({
            '-webkit-line-clamp': 'unset'
        });
    }
});}else{
    let $block = $('.content-tabs-block--detail-text');
    let parentHeight = $block.height();
    let $button = $('.content-tabs-block--detail-text__button');
    if (parentHeight > 347) {
        $button.show();
        $block.css('height', '347px');
    } else {
        $button.hide();
    }
    $('.content-tabs-block--detail-text__button').on('click', function () {
        const $block = $('.content-tabs-block--detail-text');
        const parentHeight = $block.height();
        const $button = $('.content-tabs-block--detail-text__button');

        if (parentHeight <= 347) {
            $button.text('Свернуть описание');
            $block.css('height', 'auto');
        } else {
            $button.text('Развернуть описание');
            $block.css('height', '347px');
            $('html, body').animate({
                scrollTop: $('.content-tabs').offset().top - 100  // класс объекта к которому приезжаем
            }, 500);
        }
    });
}

